import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContextMenu, toast } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

interface IDemoMenuItemProps {
  action: Parameters<typeof getIconForAction>[0];
  isDestructive?: boolean;
  label: string;
}

/**
 * ContextMenu.Item wrapper that fires a toast indicating the action will be
 * functional in production. Use this for prototype rows where we want to
 * surface the affordance without wiring real behavior.
 */
function DemoMenuItem({ action, isDestructive, label }: Readonly<IDemoMenuItemProps>): JSX.Element {
  const { t } = useTranslation();

  function handleClick(): void {
    toast(t('{{label}} runs in production.', { label }), { type: 'info' });
  }

  return (
    <ContextMenu.Item
      onClick={handleClick}
      prefix={getIconForAction(action)}
      theme={isDestructive ? 'danger' : undefined}
    >
      {label}
    </ContextMenu.Item>
  );
}

export default DemoMenuItem;
